/**
* Created by lobin on 2020/6/17.
*/
<template>
  <div class="area">
    <a-cascader
      :show-search="{ filter }"
      :field-names="{ label: 'name', value: 'code', children: 'children' }"
      :options="options"
      placeholder="请选择或者输入关键字查询"
      @change="onChange"
      v-model="initValue"
    />
  </div>
</template>

<script type="text/babel">
const regionData = require('../assets/pcas-code.json');

export default {
  props: ['value'],
  data() {
    return {
    };
  },
  computed: {
    options() {
      return regionData;
    },
    initValue() {
      return this.value;
    },
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
    filter(inputValue, path) {
      return path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">

</style>
